<template>
  <div
    id="_tlqn_member_user_info"
    class="q-pa-lg q-ma-lg bg-white rounded-borders row justify-between items-center shadow-2"
    style="height: 150px"
  >
    <div
      id="_tlqn_member_userbase_info"
      class="row justify-between items-center"
    >
      <q-avatar size="64px" class="bg-primary q-mr-lg text-white"> 
        {{
           userDetail.nickname.substr(0, 1)
        }} </q-avatar>
      <div>
        <h6>
          <strong>{{ userDetail.nickname }}</strong> {{ userDetail.group.name }}
        </h6>
        <p class="q-mx-xs">感谢参加 <strong>浙江省小微企业调查</strong></p>
        <p class="q-my-xs text-grey-8 text-caption">
          已完成总样本数的{{ `${finishedCount}/${userDetail.samples.length}` }}
        </p>
        <line-progress  :progress="progress" />
      </div>
    </div>

    <q-btn
      icon="fas fa-calendar-plus"
      size="sm"
      class="q-mb-xl"
      flat
      rounded
      color="grey-9"
      label="反馈"
      @click="showDailyReport = true"
    />
    <q-dialog v-model="showDailyReport">
      <q-card style="width: 500px">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">意见及建议反馈</div>
          <q-space />
          <q-btn icon="fas fa-times" flat round dense v-close-popup />
        </q-card-section>
        <daily-report :userDetail="userDetail" />
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import LineProgress from "../../../components/progress-bar/LineProgress.vue";
import DailyReport from "./DailyReport.vue";
export default {
  components: {
    LineProgress,
    DailyReport,
  },
  props: {
    userDetail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      showDailyReport: false,
      finishedCount: 0,
      progress: 0
    };
  },
  watch:{
    userDetail: {
      immediate: true,
      handler(){
        const finishedSample = this.userDetail.samples.filter((sample)=>{
          return sample.sample_status === 0 || sample.sample_status === 3 || sample.sample_status === 4
        })
        // console.log(finishedSample)
        this.finishedCount = finishedSample.length
        this.progress = finishedSample.length / this.userDetail.samples.length * 100
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/quasar";
</style>